export default __webpack_public_path__ + "static/media/background.22b472d1.svg";